let { HI,HERC721 } = require("h-token-staking")
let { abi } = require("./abi/NERC721.json")
let { charCompare,multiplication,longHandle } = require("h-token-staking/src/utils")

class N721 extends HI {
    constructor({ provider, account, rpcUrl, privateKey, contract }) {
        super({ provider, account, rpcUrl, privateKey, contract, abi })
    }

    async ownerOf(tokenId) {
        let owner = await this.SC.methods.ownerOf(tokenId).call()
        return owner
    }

    async balance(tokenId) {
        let owner = await this.ownerOf(tokenId)
        if(charCompare(this.web3.eth.defaultAccount,owner)) {
            return 1
        }else {
            return 0
        }
    }
    

}


module.exports = N721